export enum PersonalVerificationDocumentType {
  PASSPORT_MAIN = 'passport_main',
  PASSPORT_REG = 'passport_registration',
  SELFIE_WITH_PASSPORT = 'selfie_with_passport',
}

export enum BusinessVerificationDocumentType {
  COMPANY_REG_CERT = 'company_registration_cert',
}

export enum TerminationDocumentType {
  MOVE_OUT_PHOTO = 'move_out_photo',
}

export type VerificationDocumentType = PersonalVerificationDocumentType | BusinessVerificationDocumentType | TerminationDocumentType;

export enum VerificationFileStatus {
  PENDING = 'pending',
  APPROVED = 'approved',
  REJECTED = 'rejected',
}

export enum TerminationDocumentRejectReason {
  UNIT_NOT_CLEAN = 'unit_not_clean',
  WRONG_UNIT = 'wrong_unit',
  UNIT_NOT_IDENTIFIABLE = 'unit_not_identifiable',
  POOR_QUALITY = 'poor_photo_quality',
  UNIT_USED_AFTER_UPLOAD = 'unit_used_after_upload',
  UNIT_DAMAGED = 'unit_damaged',
  OTHER = 'other',
}

export enum VerificationDocumentRejectReason {
  POOR_QUALITY = 'poor_photo_quality',
  OTHER = 'other',
}

export type RejectDocumentReason = VerificationDocumentRejectReason | TerminationDocumentRejectReason;

export interface VerificationDocument {
  verificationPhotoId: string;
  userId: string;
  name: string;
  contractId?: string;
  documentType: VerificationDocumentType;
  fileStatus: VerificationFileStatus;
  note: Nullable<string>;
  rejectReason?: Nullable<RejectDocumentReason>;
  createdAt: string;
  updatedAt: string;
  base64?: string;
  fileUrl?: string;
  uploadDate?: string;
}
